import { ReactNode } from 'react';
import React from 'react'

type INavbarProps = {
  logo: ReactNode;
  children: ReactNode;
  backColor?: string;
};

const NavbarTwoColumns = (props: INavbarProps) => (
  <div
    style={{
      backgroundColor: props.backColor,
      fontFamily: 'BYekan',
      padding: '5px',
    }}
    className="flex flex-wrap justify-between items-center"
  >
    {props.logo}
    <style>
      {`
        .navbar :global(li:not(:first-child)) {
          @apply mt-0;
        }

        .navbar :global(li:not(:last-child)) {
          @apply mr-5;
        }
      `}
    </style>
  </div>
);

export { NavbarTwoColumns };
